const baseExportHeader = [
  { key: 'id', text: '账号ID' },
  { key: 'name', text: '账号' },
  { key: 'realname', text: '姓名' },
  { key: 'employment_type', text: '人员性质' },
  { key: 'office_location', text: '办公地点' },
  { key: 'status', text: '状态' },
  { key: 'phone', text: '手机号' },
  { key: 'mail_address', text: '个人邮箱' },
  { key: 'school', text: '目前所在院校' },
  { key: 'major', text: '专业' },
  { key: 'education_level', text: '学历' },
  { key: 'grade_level', text: '当前学年段' },
  { key: 'student_card_photos', text: '学生证照片' },
  { key: 'contract_start_date', text: '合同开始时间' },
  { key: 'contract_end_date', text: '合同结束时间' },
  { key: 'remark', text: '备注' },
  { key: 'participant_customers', text: '累计参与客户(系统自动维护,不可修改)' },
  { key: 'participant_projects', text: '累计参与项目(系统自动维护,不可修改)' },
]

// 权限控制方法
export const auditInternPermissionMixin = {
  methods: {
    /**
     * 判断是否允许查看实习生列表
     * @returns {boolean}
     */
    allowViewInternTable () {
      return filter.hasPermission(40001)
    },
    /**
     * 判断是否允许编辑/查看基础资料
     * @returns {boolean}
     */
    allowViewEditBase () {
      return filter.hasPermission(40002)
    },
    /**
     * 判断是否允许编辑/查看隐私信息
     * @returns {boolean}
     */
    allowViewEditPrivate () {
      return filter.hasPermission(40003)
    },
    /**
     * 判断是否允许编辑/查看资源控制信息
     * @returns {boolean}
     */
    allowViewEditResource () {
      return filter.hasPermission(40004)
    },
    /**
     * 判断是否允许编辑/查看分配用户资源
     * @returns {boolean}
     */
    allowViewEditUserResource () {
      return filter.hasPermission(40005)
    },
    /**
     * 判断是否允许添加实习生账号
     * @returns {boolean}
     */
    allowCreateIntern () {
      return filter.hasPermission(40006)
    },
    /**
     * 判断是否允许导出实习生隐私信息
     * @returns {boolean}
     */
    allowExportPrivateData () {
      return filter.hasPermission(40007)
    },
  },
  computed: {
    /**
     * 根据权限自动选择默认标签页
     * @returns {string}
     */
    getActiveTab () {
      if (this.allowViewEditBase()) {
        return 'baseInfo'
      } else if (this.allowViewEditPrivate()) {
        return 'privateInfo'
      } else if (this.allowViewEditResource()) {
        return 'resourceInfo'
      } else if (this.allowViewEditUserResource()) {
        return 'userResourceInfo'
      } else {
        return ''
      }
    }
  }
}

export default {
  data () {
    return {
      tableColumns: [
        { prop: 'id', label: '账号ID', minWidth: '90' },
        { prop: 'realname', label: '姓名', minWidth: '100' },
        { prop: 'name', label: '账号', minWidth: '120' },
        { prop: 'phone', label: '手机号', minWidth: '120' },
        { prop: 'employment_type', label: '人员性质', minWidth: '80', formatter: (row) => _.get(this.employmentTypeMap, row.employment_type, '-') },
        { prop: 'participant_customers', label: '累计参与客户', width: '200' },
        { prop: 'status', label: '用户状态', minWidth: '100', formatter: (row) => _.get(this.statusMap, row.status, '-') },
        { prop: 'total_work_days', label: '累计出勤天数', minWidth: '100' },
      ],
      exportBaseHeader: baseExportHeader,
      exportFullHeader: [
        ...baseExportHeader,
        { key: 'assigned_customers', text: '客户资源' },
        { key: 'ui_roles', text: 'UI角色' },
        { key: 'api_roles', text: 'API角色' },
        { key: 'id_number', text: '身份证号' },
        { key: 'id_card_front_photo', text: '身份证正面照片' },
        { key: 'id_card_back_photo', text: '身份证反面照片' },
        { key: 'bank_name', text: '银行名称' },
        { key: 'bank_branch_name', text: '支行信息' },
        { key: 'bank_card_number', text: '银行卡号' },
        { key: 'bank_card_photo', text: '银行卡照片' },
      ],
    }
  },
  computed: {
    ...Vuex.mapState({
      employmentTypeMap: state => state.auditIntern.employmentTypeMap,
      educationLevelMap: state => state.auditIntern.educationLevelMap,
      officeLocationMap: state => state.auditIntern.officeLocationMap,
      gradeLevelMap: state => state.auditIntern.gradeLevelMap,
      statusMap: state => state.auditIntern.statusMap,
    }),
  },
  methods: {
    ...auditInternPermissionMixin.methods
  },
}



// WEBPACK FOOTER //
// ./src/views/audit-intern/audit-intern.mixins.js